import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal } from 'antd'
import { useTranslation } from '@/libs/next-lang'
import { LOCAL_ENUM } from '@/constants'
import { setUserStorage, getUserStorage } from '@/services/common'
import { getLoginStatus, getSystemLocale } from '@/utils'
import Tutorial from './Tutorial'
import styles from './index.module.less'

const STORAGE_KEY = 'user.cc.works.guide.record'

export default function useTutorial({ isShow, pathname }: any): {
  show: (data: any) => void
  render: () => React.ReactNode
} {
  const [visible, setVisible] = useState(false)
  const [tutorList, setTutorList] = useState([])

  const { t } = useTranslation(['components'])

  async function getTutorList() {
    const { data: result } = await axios.get(
      `https://static.creativebooster.com/common/tutorial/t.json?t=${Date.now()}`,
      { withCredentials: false },
    )
    const lang = getSystemLocale() || LOCAL_ENUM.ZH_CN
    const tecData = result?.[lang];
    if (Array.isArray(tecData?.TEC_WORKS_VIDEO)) {
      const newTecList: any = tecData.TEC_WORKS_VIDEO.map((item: any, i: number) => ({
        id: `${i + 1}`,
        thumbnail: `${item.src}?x-oss-process=video/snapshot,t_0,w_240,m_fast`,
        poster: `${item.src}?x-oss-process=video/snapshot,t_0,m_fast`,
        ...item,
      }))
      setTutorList(newTecList)
    }
  }

  useEffect(() => {
    async function showTutorial() {
      const { data = {} } = await getUserStorage({
        keys: [STORAGE_KEY],
      })
      if (data?.code === 0) {
        const result = data?.result || {}
        setVisible(result[STORAGE_KEY] !== '1')
      }
    }
    if (isShow && getLoginStatus() && pathname === '/works') {
      getTutorList()
      showTutorial()
    }
  }, [isShow, pathname])

  const handleShow = () => {
    getTutorList()
    setVisible(true)
  }

  /**
   * 我学会了
   */
  const onKnown = async () => {
    setVisible(false)
    setUserStorage({
      key: STORAGE_KEY,
      value: '1',
    })
  }

  const renderPreview = () => {
    return (
      <Modal
        title={t('components:t105')}
        className={styles['tutorial-modal']}
        centered
        destroyOnClose
        maskClosable
        width={1132}
        open={visible}
        bodyStyle={{ padding: 0 }}
        footer={null}
        onCancel={onKnown}
      >
        <Tutorial dataSource={tutorList} onCancel={onKnown} t={t} />
      </Modal>
    )
  }
  return {
    show: handleShow,
    render: renderPreview,
  }
}
